export default __webpack_public_path__ + "static/media/letterToAnimal.670dd0d7.png";